import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { ComponentProps, useRef } from 'react';
import MaterialModal from './MaterialModal';
import { useTranslation } from 'react-i18next';

type WeblinkInfo = {
  width?: number;
  height?: number;
  reload?: boolean;
};

interface Props {
  id: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  name: string;
  url: string;
  weblinkInfo: WeblinkInfo;
}

function WeblinkModal({ headerProps, id, name, url, weblinkInfo }: Props) {
  const { t } = useTranslation();
  const ref = useRef<HTMLIFrameElement>(null);

  const fullWidth = !weblinkInfo.width && !weblinkInfo.height;

  const reloadIframe = () => {
    if (ref && 'current' in ref && ref.current) ref.current.src = url;
  };

  return (
    <MaterialModal
      id={id}
      headerProps={headerProps}
      fullWidth={fullWidth}
      onReload={weblinkInfo.reload ? reloadIframe : undefined}
      aria-label={t('PAGES.TOC_LEVEL.MODALS.WEBLINK.A11Y_LABEL')}
    >
      <iframe
        ref={ref}
        role="presentation"
        src={url}
        title={name}
        allow="fullscreen"
        width={weblinkInfo?.width}
        height={weblinkInfo?.height}
      />
    </MaterialModal>
  );
}

export default WeblinkModal;
